import {UsuarioRequest} from '../../../models/usuario.interface';
import {HttpClient, HttpRequest} from '@angular/common/http';
import {BehaviorSubject, Observable, Observer} from 'rxjs';
import {Injectable} from '@angular/core';
import {Usuario} from 'src/app/models/usuario.interface';
import {environment} from 'src/environments/environment';
import {AtualizarSenha} from '../../../models/atualizar-senha.interface';

const BASE_URL = `${environment.URL_BACKEND}/usuario`;

@Injectable({
  providedIn: 'root'
})
export class UsuarioService {

  private usuarioPrivado: Observable<Usuario>;

  private usr = JSON.parse(window.localStorage.getItem('usuario'));

  testeUsuariotk = new BehaviorSubject(this.usr);

  showMenu = new BehaviorSubject(false);

  httpOptions;


  constructor(private readonly http: HttpClient) {
    this.getUsuarioStorage();
  }

  private getUsuarioStorage() {
    this.usuarioPrivado = JSON.parse(window.localStorage.getItem('usuario'));

    this.usuarioPrivado = new Observable((observer: Observer<Usuario>) => {
      observer.next(JSON.parse(window.localStorage.getItem('usuario')));
      observer.complete();
    });
  }


  createUserMaster(usuario: UsuarioRequest): Observable<Usuario> {
    return this.http.post<Usuario>(`${BASE_URL}/master`, usuario);
  }
  updatePassword(params: AtualizarSenha): Observable<Usuario> {
    return this.http.patch<Usuario>(`${BASE_URL}/alterar-senha`, params);
  }

  deleteUser(id: number): Observable<Usuario> {
    return this.http.delete<Usuario>(`${BASE_URL}/${id}`);
  }

  listAllUsers(): Observable<Usuario[]> {
    return this.http.get<Usuario[]>(`${BASE_URL}`);
  }

  uploadPhoto(idUsuario: string, file: File) {
    const formData: FormData = new FormData();
    formData.append('id', idUsuario);
    formData.append('file', file);

    const req = new HttpRequest('PATCH', `${BASE_URL}/upload`, formData, {
      reportProgress: true,
      responseType: 'json',
    });
    return this.http.request(req);
  }

  changeTheme(idUsuario: number, theme: string): Observable<Usuario> {
    return this.http.put<Usuario>(`${BASE_URL}/edit-theme`, {idUsuario, tema: theme});
  }

  recuperarSenha(email: string) {
    return this.http.get<void>(`${BASE_URL}/esqueci-minha-senha/${email}`);
  }

  pegarVersion(): Observable<VersaoDTO> {
    return this.http.get<VersaoDTO>(`${environment.URL_BACKEND}/version`);
  }

  removeTk() {
    this.testeUsuariotk.next(undefined);
  }

  get usuario() {
    return this.usuarioPrivado;
  }

  get usuarioTk() {
    return this.testeUsuariotk;
  }
}
export interface VersaoDTO {
  versao: string;
}
